import { Flex } from "@ui/components/layout/flex/Flex";
import { SubscriptionForm } from "./components/subscription-form";
import { Success } from "./components/success";
import { styles } from "./FooterEmailSubscription.style";
import { useFooter } from "./hooks/useFooter";
import { useShowFooter } from "./hooks/useShowFooter";
import type { NewsletterPolicy } from "./types";

type Props = {
    newsletterPolicy?: NewsletterPolicy;
};

export const FooterEmailSubscription = ({ newsletterPolicy }: Props) => {
    const { headers, isPending, isSuccess, onSubmit } = useFooter();
    const { shouldHideFooter } = useShowFooter({ newsletterPolicy });

    if (shouldHideFooter) return null;

    return (
        <Flex {...styles.footer}>
            {isSuccess ? (
                <Success headers={headers} />
            ) : (
                <SubscriptionForm
                    policyAgreement={newsletterPolicy}
                    onSubmit={onSubmit}
                    isPending={isPending}
                    isSuccess={isSuccess}
                    headers={headers}
                />
            )}
        </Flex>
    );
};
